import ApiService from "./api.service";

const PublicReceptionService = {
  GetList(data) {
    return ApiService.post(`/PublicReception/GetList`, data);
  },
  Get(id) {
    return ApiService.get(`/PublicReception/Get/${id}`);
  },
  GetSecurityInfo() {
    return ApiService.get(`/PublicReception/GetSecurityInfo`);
  },
};
export default PublicReceptionService;
